import { useEffect, useState } from "react";
import styled from "styled-components";
import { PageButton } from "../styled/input/Input";
import CircularLoader from "../styled/loaders/CircularLoader";
import Toast from "../hooks/Toast";
import {
  checkRegisterDataNeedsSync,
  syncRegisterDataForAllUsers,
} from "../utils/syncRegisterData";

const SyncButton = styled(PageButton)`
  background-color: #222739;
  display: grid;
  place-content: center;
  min-width: 168px;
  min-height: 44px;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: #1b1f2d;
  }

  &.disabled {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.7;
  }
`;

const SyncRegisterButton = ({ onComplete }) => {
  const [isSyncing, setIsSyncing] = useState(false);
  const [needsSync, setNeedsSync] = useState(null);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState(" ");
  const [toastType, setToastType] = useState(undefined);

  useEffect(() => {
    checkRegisterDataNeedsSync().then(setNeedsSync);
  }, []);

  async function handleSync() {
    setIsSyncing(true);

    const result = await syncRegisterDataForAllUsers();

    if (result.success) {
      setNeedsSync(false);
      setToastType("success");
      setToastMessage(
        `Synced ${result.users} users (${result.created} created, ${result.updated} updated)`
      );
      onComplete?.(result);
    } else {
      setToastType("error");
      setToastMessage(result.message);
    }

    setOpenToast(true);
    setIsSyncing(false);
  }

  return (
    <>
      {openToast && (
        <Toast
          open={{ openToast, setOpenToast }}
          message={toastMessage}
          type={toastType}
        />
      )}

      <SyncButton
        onClick={handleSync}
        className={isSyncing ? "disabled" : undefined}
      >
        {isSyncing ? (
          <CircularLoader bg="rgba(12, 108, 243, 0.2)" size="24" color="#fff" />
        ) : (
          <p>{needsSync ? "Sync register data" : "Re-sync register data"}</p>
        )}
      </SyncButton>
    </>
  );
};

export default SyncRegisterButton;
